import type React from "react";

// The one required-field asterisk. Every label renders it the same way: straight after the label
// text, one space in, in the AA error colour. Hidden from screen readers by default because the
// control itself carries `required`, which is announced; pass decorative={false} where the
// asterisk is the explanation (the "* Indicates required" notice, which also drops the gap).
const RequiredMarker: React.FC<{ decorative?: boolean; spaced?: boolean }> = ({ decorative = true, spaced = true }) => (
    <span className={(spaced ? "ml-1 " : "") + "font-semibold text-(--ecpi-error-text-hex)"} aria-hidden={decorative ? true : undefined}>*</span>
);

export default RequiredMarker;
